import { useQuery } from '@tanstack/react-query'

import axios, { AxiosResponse } from 'axios'
import { Lender } from '../types/product'

type FetchLendersResponse = {
  success: boolean
  items: Lender[]
}

const { REACT_APP_COMMS_URL } = process.env

const fetchLenders = async (apiKey?: string) => {
  // let token = ''
  // let tokenRequest: AxiosResponse = await axios.post(
  //   `${REACT_APP_COMMS_URL}/api/requestJwtToken/27tec`,
  //   null,
  //   {
  //     headers: {
  //       Authorization: `Bearer ${REACT_APP_TOKEN_PASSCODE}`,
  //     },
  //   }
  // )

  // if (tokenRequest) {
  //   const parsedToken = tokenRequest.data?.data?.body || tokenRequest.data?.body
  //   token = parsedToken?.token
  //   sessionStorage.setItem('token', token)
  const apiKeyParams = apiKey ? { apiKey } : {}

  const response: AxiosResponse<FetchLendersResponse> = await axios.post(
    `${REACT_APP_COMMS_URL}/api/27tec/lender`,
    {
      searchText: '',
      ...apiKeyParams,
    }
    // {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // }
  )

  return response.data.items
  // }
}

const useGetLenders = (apiKey?: string) => {
  return useQuery({
    queryKey: ['fetchLenders'],
    queryFn: () => fetchLenders(apiKey),
    refetchOnWindowFocus: false,
  })
}

export default useGetLenders
